import "./MessageSubmitWaitingHint.scss";

/**
 * Shown under an interactive message form when its response is stored but the
 * execution has not continued yet (see useMessageSubmitLock).
 */
export const MessageSubmitWaitingHint = ({ visible }: { visible: boolean }) =>
    visible ? (
        <p className="messageSubmitWaitingHint" role="status">
            Waiting for the execution to continue…
        </p>
    ) : null;
